const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/persons/$id.general.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindCompanyLinkCategoriesQueryOptions, getFindCompanySitesMinifiedQueryOptions, getFindPersonArtistsQueryOptions, getFindPersonAssignableUsersQueryOptions, getFindPersonDetailsQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/persons/$id/general')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindPersonDetailsQueryOptions(params.id));
    queryClient.ensureQueryData(getFindPersonArtistsQueryOptions(params.id));
    queryClient.ensureQueryData(getFindCompanyLinkCategoriesQueryOptions());
    queryClient.ensureQueryData(getFindCompanySitesMinifiedQueryOptions());
    queryClient.ensureQueryData(getFindPersonAssignableUsersQueryOptions(params.id));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});